import React from "react";
import { Modal, Button, ButtonGroup, IconWarningAlt } from "@veneer/core";

interface EvaluationConfirmModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  actualCourse: any;
  t: (key: string) => string;
}

export const EvaluationConfirmModal: React.FC<EvaluationConfirmModalProps> = ({
  show,
  onClose,
  onConfirm,
  actualCourse,
  t,
}) => {
  return (
    <div style={{ position: "relative" }}>
      <Modal
        className="modalValidation"
        closeButton={true}
        align="center"
        id="modalValidation"
        show={show}
        onClose={onClose}
        footer={
          <ButtonGroup className="validationTestButtonGroup">
            <Button onClick={onConfirm}>{t("header.startEvaluation")}</Button>
            <Button onClick={onClose} appearance="secondary">
              {t("header.cancel")}
            </Button>
          </ButtonGroup>
        }
        title={t("header.evaluation") + " " + actualCourse?.courseName}
      >
        <IconWarningAlt size={120} />
        <br />
        <b>{t("header.evaluationAlert")}</b>
      </Modal>
    </div>
  );
};
